<div class="filtros">
  <mat-form-field appearance="outline" style="width: 100%">
    <mat-label>Buscar</mat-label>
    <input
      matInput
      [(ngModel)]="filtroTexto"
      placeholder="Nome do arquivo ou status"
      (keyup)="aplicarFiltro()"
    />
  </mat-form-field>
</div>

<table mat-table [dataSource]="dataSource" class="cis-default-table" matSort>
  <!-- Nome do Arquivo -->
  <ng-container matColumnDef="nomeArquivo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivo</th>
    <td mat-cell *matCellDef="let item">{{ item.nomeArquivo }}</td>
  </ng-container>

  <!-- Data de Criação -->
  <ng-container matColumnDef="dataCriacao">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Data</th>
    <td mat-cell *matCellDef="let item">
      {{ item.dataCriacao | date:'dd/MM/yyyy HH:mm' }}
    </td>
  </ng-container>

  <!-- Linhas Processadas -->
  <ng-container matColumnDef="linhasProcessadas">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Processadas</th>
    <td mat-cell *matCellDef="let item">{{ item.linhasProcessadas }}</td>
  </ng-container>

  <!-- Linhas com Erro -->
  <ng-container matColumnDef="linhasComErro">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Erros</th>
    <td mat-cell *matCellDef="let item">{{ item.linhasComErro }}</td>
  </ng-container>

  <!-- Status -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
    <td mat-cell *matCellDef="let item">
      @if (item.status === 'FINALIZADO_SUCESSO') {
      <span class="status-pill status-active">Finalizado com sucesso</span>
      } @else if (item.status === 'FINALIZADO_COM_ERRO') {
      <span class="status-pill status-erro">Finalizado com erros</span>
      } @else if (item.status === 'ERRO_FATAL') {
      <span class="status-pill status-erro">Finalizado com erro</span>
      }
    </td>
  </ng-container>

  <!-- Açoes -->
  <ng-container matColumnDef="acoes">
    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
    <td mat-cell *matCellDef="let item">
      @if (item.status === 'FINALIZADO_COM_ERRO' || item.status ===
      'ERRO_FATAL') {
      <button
        (click)="baixarRelatorioErros(item.id)"
        class="remover"
        title="Baixar relatório de erros"
      >
        <mat-icon>download</mat-icon>
      </button>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
  ></tr>
</table>

<div class="paginator-container">
  <p class="contagem-texto">{{ textoContagem }}</p>

  <mat-paginator
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)"
  ></mat-paginator>
</div>
